import React, { Component } from 'react';
import * as mat from 'material-ui';
import { connect } from 'react-redux';
import './style.css'


class ViewScore extends Component {
    render() {
        // console.log(this.props.scores, "scores")
        return (
            <div>
                <mat.Card
                    zDepth={0}
                    className='col-md-8 col-md-offset-2 col-xs-10 col-xs-offset-1'
                >
                    <div className="page-header text-center">
                        <p style={{ fontSize: '5.5vh', fontFamily: 'arial', fontWeight: 'bold' }}>
                            Score Board
                        </p>
                    </div>
                    <div className='col-md-10 col-md-offset-1'>
                        {Object.keys(this.props.scores).map((keys, i) => {
                            let v = this.props.scores[keys];
                            return (
                                <mat.Card key={i} className='col-md-10 col-md-offset-1 card-list'>
                                    <mat.List className='card-list1'>
                                        <mat.ListItem
                                            primaryText={
                                                <span className='teamName' style={{ fontSize: "1.8em" }}>
                                                    {v.teamName}
                                                </span>
                                            }
                                            secondaryText={
                                                <span>
                                                    <span className='totalScore' style={{ paddingLeft: '5%' }}>
                                                        Score: {v.result.totalScore} {" "}
                                                    </span>
                                                    <span className='correctAnswers' style={{ paddingLeft: '5%' }}>
                                                        Correct Answers: {v.result.correctAnswers}
                                                    </span>
                                                </span>

                                            }
                                        />
                                    </mat.List>
                                </mat.Card>
                            )
                        })
                        }
                    </div>
                </mat.Card>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        scores: state.ScoreReducers.scoreResult
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        // FetchDetailsQuiz: (quizKey) => {
        //     dispatch(FetchDetailsQuiz(quizKey));
        // }

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ViewScore);


// WEBPACK FOOTER //
// ./src/component/viewscore.js